import * as React from 'react';
import {Button, Form} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import InputFormItem from '../common/form-items/InputFormItem';
import locales from '../locales';
import {TransportDto} from '../api/dtos/dtos';
import * as formUtils from '../utils/form-utils';
import {addressSuffix} from '../utils/form-utils';
import FormItem from "antd/lib/form/FormItem";
import ClientNameAutoCompleteFormItem from "../common/form-items/ClientNameAutoCompleteFormItem";

interface Props extends FormComponentProps {
  transport?: TransportDto;
  onCancel: () => void;
  onDownload: () => void;
  onSave: (details: TransportDto) => void;
}

const FIELD_TRANSPORT_COMPANY = 'organization';
const FIELD_DRIVER_NAME = 'name';
const FIELD_DRIVER_MOTHERS_NAME = 'mothersName';
const FIELD_DRIVER_ID = 'idNumber';
const FIELD_START_ADDRESS = 'startAddress';
const FIELD_END_ADDRESS = 'endAddress';
const FIELD_LICENSE_PLATE = 'licensePlate';

class TransportLetterForm extends React.Component<Props, {}> {

  public render() {
    const {form, transport} = this.props;
    return (
      <>
        <Form>
          <ClientNameAutoCompleteFormItem
            form={form}
            fieldId={FIELD_TRANSPORT_COMPANY}
            label={locales.transport_company_name}
            initialValue={transport && transport.company}
            required={false}
          />
          <InputFormItem
            form={form}
            fieldId={FIELD_DRIVER_NAME}
            label={locales.driver_name}
            initialValue={transport && transport.driver}
            required={false}
          />
          <InputFormItem
            form={form}
            fieldId={FIELD_DRIVER_MOTHERS_NAME}
            label={locales.mothers_name}
            initialValue={transport && transport.mothersName}
            required={false}
          />
          <InputFormItem
            form={form}
            fieldId={FIELD_DRIVER_ID}
            label={locales.id_number}
            initialValue={transport && transport.idNumber}
            required={false}
          />
          <InputFormItem
            form={form}
            fieldId={FIELD_START_ADDRESS}
            label={locales.start_address}
            initialValue={transport && transport.start}
            required={false}
            addonAfter={transport && addressSuffix(transport.start)}
          />
          <InputFormItem
            form={form}
            fieldId={FIELD_END_ADDRESS}
            label={locales.end_address}
            initialValue={transport && transport.end}
            required={false}
            addonAfter={transport && addressSuffix(transport.end)}
          />
          <InputFormItem
            form={form}
            fieldId={FIELD_LICENSE_PLATE}
            label={locales.licensePlate}
            initialValue={transport && transport.licensePlate}
            required={false}
          />
        </Form>

        {this.props.children}

        <FormItem {...formUtils.tailFormItemLayout}>
          <Button type="primary" onClick={this.onFormSubmit}>{locales.save}</Button>
          {transport && transport.id &&
              <Button style={{marginLeft: 8}} onClick={this.onDownload}>{locales.download}</Button>
          }
          <Button style={{marginLeft: 8}} onClick={this.onFormCancel}>{locales.cancel}</Button>
        </FormItem>
      </>
    );
  }

  private onDownload = () => {
    this.props.onDownload();
  }

  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onCancel();
  };

  private onFormSubmit = () => {
    const {transport, form, onSave} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onSave({
          id: transport?.id ?? null,
          company: values[FIELD_TRANSPORT_COMPANY],
          driver: values[FIELD_DRIVER_NAME],
          mothersName: values[FIELD_DRIVER_MOTHERS_NAME],
          idNumber: values[FIELD_DRIVER_ID],
          start: values[FIELD_START_ADDRESS],
          end: values[FIELD_END_ADDRESS],
          licensePlate: values[FIELD_LICENSE_PLATE],
        });
      }
    });
  };

}

export default Form.create<Props>()(TransportLetterForm);



// WEBPACK FOOTER //
// ./src/rental-details/TransportLetterForm.tsx